// @flow
import isPointGeotype from './isPointGeotype';

export const radiusStringToInt = (radius: ?string) =>
  radius === 'auto' ? null : radius === 'country' ? -1 : parseInt(radius, 10);

export const radiusIntToString = (radius: ?number, geoType: ?string) => {
  if (!radius && isPointGeotype(geoType)) {
    return 'auto';
  }
  if (radius === -1) {
    return 'country';
  }
  return radius ? String(radius) : null;
};
